<div class="login-container container-fluid" *ngIf="currentScreenFlow === CreateAccountFlow.emailSetup">
  <app-create-otp-v0 (createOTPResponse)="createOTPResponse($event)"></app-create-otp-v0>
</div>
<!-- Success step-->
<div class="account-parent" *ngIf="currentScreenFlow === CreateAccountFlow.successStep">
  <app-success-step-v0></app-success-step-v0>
</div>
<div class="account-parent" *ngIf="currentScreenFlow != CreateAccountFlow.emailSetup && currentScreenFlow != CreateAccountFlow.successStep">
  <div class="back-step">
    <a href="javascript:void(0)" (click)="previousScreen()">
      <adp-label labelKey="Signup_Create_Account_BackStep_Text"></adp-label>
    </a>
  </div>
  <div class="account-setup">
    <!--<div class="step-text" role="heading" aria-level="1">
      <adp-label labelKey="Global_Step"></adp-label>&nbsp;{{ currentStep }}&nbsp;<adp-label
        labelKey="Global_Of"></adp-label>&nbsp;{{totalStep}}
    </div>-->
    <div class="step-text"></div>
    <div class="col-12">
      <div class="header-text heading">{{heading}}</div>
    </div>

    <!-- OTP step -->
    <div *ngIf="currentScreenFlow === CreateAccountFlow.otpSetup">
      <app-verify-otp-v0 [email]="email" [encryptedEmail]="encryptedEmail" [maskedEmail]="maskedEmail" [encryptedOTP]="encryptedOTP" [firstName]="firstName"
        (verifyOTPResponse)="verifyOTPResponse($event)"
        (resendOTPResponse)="createOTPResponse($event)"></app-verify-otp-v0>
    </div>

    <!-- Contact Setup step-->
    <div *ngIf="currentScreenFlow === CreateAccountFlow.contactSetup">
      <app-contact-setup-v0 [contactInfo]="contactInfo" (submitted)="contactInfoSubmitted($event)"></app-contact-setup-v0>
    </div>

    <!-- Create password step -->
    <form [formGroup]='passwordForm' (ngSubmit)='signUp()' class="mt-32"
      *ngIf="currentScreenFlow === CreateAccountFlow.passwordSetup" fxLayout='column' fxLayoutAlign='start stretch'>
      <pgh-password-form [forFormGroup]="passwordForm" [passwordLabelSFKey]="'PasswordForm_PasswordField_Label'" [confirmPasswordLabelSFKey]="'PasswordForm_ConfirmPasswordField_Label'"></pgh-password-form>

      <div class="mt-32">
        <button mat-flat-button color='accent' type="submit" [disabled]='passwordForm.invalid || signUpInProgress'>
          <adp-label labelKey="PasswordForm_Submit_Button_Text"></adp-label>
          <mat-spinner class='sign-up-progress-indicator' diameter='20' *ngIf='signUpInProgress'></mat-spinner>
        </button>
      </div>
    </form>
  </div>
</div>
